module.exports = __webpack_public_path__ + "static/media/sci-logo-dark.058f7f85.svg";